import React from 'react';
import styles from 'page/css/Audio.module.css';
import defaultImage from "asset/images/images.png";
import Button from "../inputs/Button";
import {Chip, FormControl, Switch, TextField} from "@mui/material";

import { imageMimeType } from "../../config";
import { useFormatFile } from "service/util/useFormatFile";
import { useDispatch, useSelector } from "react-redux";
import { audioActions } from "reducers/audio";
import Swal from "sweetalert2";
import checkByteSize from "../../service/util/checkByteSize";

const AudioForm = ({ create }) => {
    const dispatch = useDispatch();
    const audioDetail = useSelector(state => state.audioData.audioDetail);
    const typeSelect = useSelector(state => state.audioData.typeSelect);
    const previewImage = useSelector(state => state.audioData.previewImage);
    const previewImageMap = useSelector(state => state.audioData.previewImageMap);
    const img = useFormatFile(previewImage ? previewImage : null);
    const mapImg = useFormatFile(previewImageMap ? previewImageMap : null);
    const { typeId } = typeSelect;

    const onChangeInput = (e) => {
        const { name, value } = e.target;
        dispatch(audioActions.setAudioDetail({
            ...audioDetail,
            [name]: value,
        }));
    }
    const onChangeSwitch = (e) => {
        dispatch(audioActions.setAudioDetail({
            ...audioDetail,
            invalid: !e.target.checked,
        }));
    }
    const onChangeFileHandler = (e, image, mapImage) => {
        e.preventDefault();
        const imageFile = e.target.files[0];
        if (!imageFile.type.match(imageMimeType)) {
            dispatch(audioActions.setOpenModal(false));
            Swal.fire({
                text: "해당 형식의 파일은 지원하지 않습니다.\nJPG, PNG 파일을 등록해 주세요.",
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(r => { if (r.isConfirmed) {
                dispatch(audioActions.setOpenModal(true));
                return false;
            }});
        } else if (checkByteSize(imageFile.size)) {
            dispatch(audioActions.setOpenModal(false));
            Swal.fire({
                text: `이미지 용량은 5MB 이내로 등록 가능합니다.`,
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(r => { if (r.isConfirmed) {
                dispatch(audioActions.setOpenModal(true));
                return false;
            }});
        } else {
            if (mapImage) {
                dispatch(audioActions.setAudioDetail({ ...audioDetail, mapImageUrl: null }));
                dispatch(audioActions.setImageMapFile(imageFile));
                dispatch(audioActions.setPreviewMapImage(imageFile));
            } else {
                dispatch(audioActions.setAudioDetail({ ...audioDetail, imageUrl: null }));
                dispatch(audioActions.setImageFile(imageFile));
                dispatch(audioActions.setPreviewImage(imageFile));
            }
        }
    }
    const onChangeAudioFileHandler = (e) => {
        e.preventDefault();
        const audioFile = e.target.files[0];
        dispatch(audioActions.setAudioFile(audioFile));
    }

    return (
        <form className={styles.audioFormWrap} encType={"multipart/form-data"}>
            <input type={"hidden"} value={audioDetail?.id || ""} />
            <div className={`${styles.audioTextContainer}`}>
                <article>
                    <Chip label="오디오 제목" sx={{ marginBottom: "0.7rem" }} />
                    <TextField className={`textInput ${styles.textInput}`} defaultValue={audioDetail?.title ? audioDetail.title || "" : ""} onChange={onChangeInput} label={create ? "타이틀" : null} name={"title"} variant="outlined" size={"small"}  />
                    <Chip label="오디오 자막" sx={{ marginBottom: "0.7rem" }} />
                    <TextField className={`textInput ${styles.textInput}`} defaultValue={audioDetail?.script ? audioDetail.script || "" : ""} onChange={onChangeInput} label={create ? "스크립트" : null} name={"script"} variant="outlined" size={"small"} multiline rows={4} />
                    {typeId === 3 &&
                        <>
                        <Chip label="오디오 이미지 대체 문구" sx={{ marginBottom: "0.7rem" }} />
                        <TextField className={`textInput ${styles.textInput}`} defaultValue={audioDetail?.imageAltText ? audioDetail.imageAltText || "" : ""} onChange={onChangeInput} label={create ? "이미지 대체 문구" : null} name={"imageAltText"} variant="outlined" size={"small"}  />
                        </>
                    }
                </article>
                <article>
                    <FormControl className={styles.audioInvalidContainer}>
                        <Chip className={styles.audioLabel} label="활성화 여부" sx={{ marginBottom: "0.7rem"}} />
                        <div>
                            <span>OFF</span>
                            <Switch
                                name={"invalid"}
                                onChange={onChangeSwitch}
                                sx={{ margin: "0" }}
                                defaultChecked={audioDetail?.invalid === false || audioDetail?.invalid === "false"}
                            />
                            <span>ON</span>
                        </div>
                    </FormControl>
                    <div className={styles.audioFileContainer}>
                        <Chip label="오디오 파일" sx={{ marginBottom: "0.7rem"}} />
                        {audioDetail?.audioUrl ?
                            <>
                            <span className={"caption"}>저장된 오디오 파일이 있습니다.</span>
                            <input type="file" accept={"audio/*"} name={"audioUrl"} onChange={(e) => onChangeAudioFileHandler(e)} />
                            </>
                            : <input type="file" accept={"audio/*"} name={"audioUrl"} onChange={(e) => onChangeAudioFileHandler(e)} />
                        }
                    </div>
                </article>
            </div>
            <ul className={`${styles.audioImageContainer}`}>
                <li>
                    <div>
                        <Chip label="오디오 이미지 등록" sx={{ marginBottom: "0.7rem"}} />
                        { create
                            ? <img src={img === null ? defaultImage : previewImage ? img : defaultImage} alt={"preview"} />
                            : <img src={previewImage ? img : audioDetail?.thumbnailUrl !== null ? audioDetail?.thumbnailUrl : defaultImage} alt={"preview"} />
                        }
                        <input id="imageFile" type={"file"} multiple="multiple" name={"imageUrl"} accept={"image/*"} onChange={(e) => onChangeFileHandler(e, true, false)} style={{ display: "none" }} />
                    </div>
                    <label className={"labelBtn audio"} htmlFor={"imageFile"}>{create ? "등록" : "변경"}</label>
                </li>
                <li>
                    <div>
                    <Chip label="오디오 지도 이미지 등록" sx={{ marginBottom: "0.7rem"}} />
                        { create
                            ? <img src={mapImg === null ? defaultImage : previewImageMap ? mapImg : defaultImage} alt={"preview"} />
                            : <img src={previewImageMap ? mapImg : audioDetail?.mapImageUrl !== null ? audioDetail?.mapImageUrl : defaultImage} alt={"preview"} />
                        }
                    <input id="imageMapFile" type={"file"} multiple="multiple" name={"mapImageUrl"} accept={"image/*"} onChange={(e) => onChangeFileHandler(e, false, true)}  style={{ display: "none" }} />
                    </div>
                    <label className={"labelBtn audio"} htmlFor={"imageMapFile"}>{create ? "등록" : "변경"}</label>
                </li>
            </ul>
        </form>
    );
};

export default AudioForm;